// // src/context/AuthContext.tsx
// import React, { createContext, useContext, useMemo, useState } from "react";
// import { tokenStore } from "../services/tokenStore";

// type Tokens = {
//   accessToken?: string;
//   idToken?: string;
//   sessionToken?: string;
//   [k: string]: any;
// };

// type AuthCtx = {
//   doctor: any | null;
//   tokens: Tokens | null;

//   setAuth: (tokens: Tokens, doctor: any) => void;
//   login: (doctor: any) => void;
//   logout: () => void;
// };

// const Ctx = createContext<AuthCtx | null>(null);

// export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
//   const saved = tokenStore.get();

//   const [doctor, setDoctor] = useState<any | null>(saved.user || null);
//   const [tokens, setTokens] = useState<Tokens | null>(
//     saved && (saved.accessToken || saved.idToken) ? (saved as any) : null
//   );

//   const setAuth = (newTokens: Tokens, newDoctor: any) => {
//     setTokens(newTokens);
//     setDoctor(newDoctor);
//     tokenStore.set({ ...newTokens, user: newDoctor });
//   };

//   const login = (doc: any) => {
//     setDoctor(doc);
//     const current = tokenStore.get();
//     tokenStore.set({ ...current, user: doc });
//   };

//   const logout = () => {
//     // 1️⃣ Clear app state
//     setTokens(null);
//     setDoctor(null);

//     // 2️⃣ Clear storage
//     // tokenStore.clear();
//     // localStorage.clear();
//     // sessionStorage.clear();
//     tokenStore.clear();
// // do NOT clear all localStorage, only your key
// sessionStorage.clear(); // ok if you only use it for this app

//     // 3️⃣ Optional: Auth0 logout (recommended)
//     const domain = process.env.REACT_APP_AUTH0_DOMAIN;
//     const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
//     const returnTo = window.location.origin;

//     if (domain && clientId) {
//       window.location.href =
//         `https://${domain}/v2/logout?client_id=${clientId}&returnTo=${returnTo}`;
//     }
//   };

//   const value = useMemo(
//     () => ({ doctor, tokens, setAuth, login, logout }),
//     [doctor, tokens]
//   );

//   return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
// };

// export const useAuth = () => {
//   const v = useContext(Ctx);
//   if (!v) throw new Error("useAuth must be used within AuthProvider");
//   return v;
// };

// src/context/AuthContext.tsx
import React, {
  createContext,
  useContext,
  useMemo,
  useState,
  useEffect,
} from "react";
import { tokenStore } from "../services/tokenStore";
import axios from "axios";

type Tokens = {
  accessToken?: string;
  idToken?: string;
  sessionToken?: string;
  [k: string]: any;
};

type AuthCtx = {
  doctor: any | null;
  tokens: Tokens | null;
  currentUser: any | null;

  setAuth: (tokens: Tokens, doctor: any) => void;
  login: (doctor: any) => void;
  logout: () => void;
  refreshCurrentUser: () => Promise<void>;
};

const Ctx = createContext<AuthCtx | null>(null);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const saved = tokenStore.get();

  const [doctor, setDoctor] = useState<any | null>(saved.user || null);
  const [tokens, setTokens] = useState<Tokens | null>(
    saved && (saved.accessToken || saved.idToken) ? (saved as any) : null,
  );

  const [currentUser, setCurrentUser] = useState<any | null>(null);

  // ✅ Fetch current user (REUSABLE)
  const fetchCurrentUser = async () => {
    try {
      const token = tokens?.accessToken;
      if (!token) return;

      const res = await axios.get(
        "https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/usermanagement/api/auth0/currentUser",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setCurrentUser(res.data);
    } catch (err) {
      console.error("Failed to fetch current user", err);
    }
  };

  // ✅ Auto-fetch when tokens change
  useEffect(() => {
    if (tokens?.accessToken) {
      fetchCurrentUser();
    }
  }, [tokens]);

  const setAuth = (newTokens: Tokens, newDoctor: any) => {
    setTokens(newTokens);
    setDoctor(newDoctor);
    tokenStore.set({ ...newTokens, user: newDoctor });
  };

  const login = (doc: any) => {
    setDoctor(doc);
    const current = tokenStore.get();
    tokenStore.set({ ...current, user: doc });
  };

  const logout = () => {
    setTokens(null);
    setDoctor(null);
    setCurrentUser(null);

    tokenStore.clear();
    sessionStorage.clear();

    const domain = process.env.REACT_APP_AUTH0_DOMAIN;
    const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
    const returnTo = window.location.origin;

    if (domain && clientId) {
      window.location.href = `https://${domain}/v2/logout?client_id=${clientId}&returnTo=${returnTo}`;
    }
  };

  const value = useMemo(
    () => ({
      doctor,
      tokens,
      currentUser,
      setAuth,
      login,
      logout,
      refreshCurrentUser: fetchCurrentUser,
    }),
    [doctor, tokens, currentUser],
  );

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useAuth = () => {
  const v = useContext(Ctx);
  if (!v) throw new Error("useAuth must be used within AuthProvider");
  return v;
};
